module.exports = __webpack_public_path__ + "static/media/Location_pin.3934648d.svg";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/assets/Location_pin.svg
// module id = 1543
// module chunks = 1137